// -------------------------------------
//  MatchHeight
//  https://www.npmjs.com/package/jquery-match-height
// -------------------------------------
import 'jquery-match-height';

export default function MatchHeight(group, item){
  // basic usage
  $(group).each(function() {
    $(this).children(item).matchHeight();
  });
}
